import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { TableModule, Table } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { Scheda } from '../../models/scheda.model';
import { StiliService } from '../../services/stili.service';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TabViewModule } from 'primeng/tabview';
import { Menu } from 'primeng/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import localeIt from '@angular/common/locales/it';
import { SchedeService } from '../../services/schede.service';
import { ComuniService } from '../../services/comuni.service';
import { ExcelService } from '../../services/excelService.service';
import { BaciniService } from '../../services/bacini.service';
import { FirebaseStorageService } from '../../services/firebase-storage.service';
import { InterventiService } from '../../services/interventi.service';
import { NuovoInterventoComponent } from './nuovo-intervento/nuovo-intervento.component';
import { Intervento } from '../../models/intervento.model';
import { ConfermaFinanziamentoComponent } from './conferma-finanziamento/conferma-finanziamento.component';
import { RendicontaComponent } from './rendiconta/rendiconta.component';
import { StatoRendicontazioneComponent } from './stato-rendicontazione/stato-rendicontazione.component';
import FileSaver, { saveAs } from 'file-saver';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import player from 'lottie-web';
import { DeterminaComponent } from './determina/determina.component';
import { MappaInterventoComponent } from './mappa-intervento/mappa-intervento.component';
import { SchedeFeatureCollection } from '../../models/scheda-geojson.model';
import * as maplibregl from 'maplibre-gl';
import { ComuniFeatureCollection } from '../../models/comune-geojson.model';
import proj4 from 'proj4';
import { RichiesteService } from '../../services/richieste.service';
import { Richiesta } from '../../models/richiesta.model';
import { RiproponiInterventoComponent } from './riproponi-intervento/riproponi-intervento.component';
import { RimodulaRichiestaComponent } from './rimodula-richiesto/rimodula-richiesto.component';
import { EliminaInterventoComponent } from './elimina-intervento/elimina-intervento.component';
import { StoricoInterventoComponent } from './storico/storico.component';
import { ModificaInterventoComponent } from './modifica-intervento/modifica-intervento.component';
import { ModificaRendicontazioneComponent } from './modifica-rendicontazione/modifica-rendicontazione.component';
import { AssegnaMassivamenteDetermineComponent } from './assegna-massivamente-determine/assegna-massivamente-determine.component';
import { CaricaDocumentiRendicontazioneComponent } from './carica-documenti-rendicontazione/carica-documenti-rendicontazione.component';
import {
  StatoIntervento,
  StatoInterventoEnum,
} from '../../models/stato-intervento.model';
import { ModificaNoteInterventoComponent } from './modifica-note-intervento/modifica-note-intervento.component';
import { LiquidazioneInterventoComponent } from './liquidazione-intervento/liquidazione-intervento.component';
import { StoricoLiquidazioniComponent } from './storico-liquidazioni/storico-liquidazioni.component';

export function playerFactory() {
  return player;
}
registerLocaleData(localeIt);

@Component({
  selector: 'app-interventi',
  templateUrl: './interventi.component.html',
  styleUrls: ['./interventi.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    TagModule,
    TooltipModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    TieredMenuModule,
    TabViewModule,
    CheckboxModule,
    InputSwitchModule,
    NuovoInterventoComponent,
    RimodulaRichiestaComponent,
    ConfermaFinanziamentoComponent,
    RendicontaComponent,
    LottieComponent,
    DeterminaComponent,
    MappaInterventoComponent,
    RiproponiInterventoComponent,
    EliminaInterventoComponent,
    StoricoInterventoComponent,
    StatoRendicontazioneComponent,
    ModificaInterventoComponent,
    ModificaRendicontazioneComponent,
    CaricaDocumentiRendicontazioneComponent,
    AssegnaMassivamenteDetermineComponent,
    ModificaNoteInterventoComponent,
    LiquidazioneInterventoComponent,
    StoricoLiquidazioniComponent,
  ],
  providers: [MessageService],
})
export class InterventiComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dt') dt!: Table;
  @ViewChild(NuovoInterventoComponent)
  nuovoInterventoComponent!: NuovoInterventoComponent;
  @ViewChild(ConfermaFinanziamentoComponent)
  confermaFinanziamentoComponent!: ConfermaFinanziamentoComponent;
  @ViewChild(RendicontaComponent) rendicontaComponent!: RendicontaComponent;
  @ViewChild(DeterminaComponent) determinaComponent!: DeterminaComponent;
  @ViewChild(MappaInterventoComponent)
  mappaInterventoComponent!: MappaInterventoComponent;
  @ViewChild('map') mapContainer!: ElementRef;
  @ViewChild('mapTooltip') mapTooltipEl!: ElementRef;
  @ViewChild(RiproponiInterventoComponent)
  riproponiInterventoComponent!: RiproponiInterventoComponent;
  @ViewChild(RimodulaRichiestaComponent) rimodulaRichiestaComponent: any;
  @ViewChild(StoricoInterventoComponent)
  storicoInterventoComponent!: StoricoInterventoComponent;
  @ViewChild(StoricoLiquidazioniComponent)
  storicoLiquidazioniComponent!: StoricoLiquidazioniComponent;
  @ViewChild(StatoRendicontazioneComponent)
  statoRendicontazioneComponent!: StatoRendicontazioneComponent;
  @ViewChild(ModificaInterventoComponent)
  modificaInterventoComponent!: ModificaInterventoComponent;
  @ViewChild(ModificaNoteInterventoComponent)
  modificaNoteInterventoComponent!: ModificaNoteInterventoComponent;

  titoloInterventi: string = 'INTERVENTI';
  isEnteEsecutore: boolean = false;
  isAdminOrUmvs: boolean = false; // Verifica se l'utente è ADMIN, SUPERADMIN o UMVS
  enteId: string | null = null;

  // Tab attivo
  activeTabIndex: number = 0;

  // Array per gli interventi
  interventi: any[] = [];
  interventiFiltrati: any[] = [];
  interventiOriginali: any[] = [];
  interventiCaricati: boolean = false;

  statiIntervento: StatoIntervento[] = [];
  statiInterventoConRimuovi: any[] = []; // Lista degli stati con opzione "Rimuovi filtro"
  statoSelezionato: StatoIntervento | null = null;

  // Filtri
  filtri = {
    bacino: null as any | null,
    comune: null as any | null,
    anno: null as any | null,
  };
  filtriAttivi: boolean = false;
  filtroTestoGlobale: string = '';
  filtroCodiceCastale: string | null = null;
  filtroConsorzio: string | null = null;
  filtroAnno: string | null = null;
  filtroRichiestaId: string | null = null;
  filtroScheda: string | null = null;
  filtroCodiceScheda: string | null = null;
  // Filtro per mostrare/nascondere interventi di altri enti quando si arriva da una richiesta
  mostraSoloInterventiEnteRichiesta: boolean = false; // Di default mostra tutti gli enti
  enteIdRichiesta: string | null = null; // ID dell'ente della richiesta corrente
  interventoLiquidazione: Intervento | null = null;
  dataLiquidazione: string | null = null;
  // Menu azioni
  menuAzioniItems: MenuItem[] = [];
  @ViewChild('azioniMenuTiered') azioniMenuTiered!: Menu;
  selectedIntervento: any | null = null;

  // Proprietà per la modale di conferma cancellazione
  showConfermaCancellazione: boolean = false;
  interventoDaEliminare: Intervento | null = null;

  // Colonne della tabella
  cols: any[] = [];

  // Ordinamento di default: per anno decrescente, poi per importoRichiesto crescente
  multiSortMeta: any[] = [
    { field: 'richiesta.anno', order: -1 },
    { field: 'importoRichiesto', order: 1 },
  ];

  mostraComunicaContributo: boolean = false;
  interventoComunicaContributo: Intervento | null = null;
  mostraConfermaFinanziamento: boolean = false;
  interventoConfermaFinanziamento: Intervento | null = null;
  public mostraRendiconta: boolean = false;
  public interventoRendiconta: Intervento | null = null;
  mostraComunicaDetermina: boolean = false;
  interventoComunicaDetermina: Intervento | null = null;
  mostraAssegnaMassivamenteDetermine: boolean = false;
  mostraRimodulaRichiesta: boolean = false;
  mostraLiquidazione: boolean = false;

  isDownloading: boolean = false;
  options: AnimationOptions = {
    path: '/assets/animations/spinner-downloading.json',
    loop: true,
    autoplay: true,
  };

  anniDisponibili: any[] = [];
  annoSelezionato: any = null;
  richieste: Richiesta[] = [];
  richiesteConRimuovi: any[] = []; // Lista delle richieste con opzione "Rimuovi filtro"
  richiestaSelezionata: Richiesta | null = null;

  showMappaIntervento: boolean = false;
  mappaInterventoTitolo: string = 'Posizione intervento';
  interventoSelezionato: Intervento | null = null;
  schedaIntervento: Scheda | null = null;
  selectedFeatureGeoJSON: any = null;

  // Mappa
  private map: maplibregl.Map | null = null;
  private markers: maplibregl.Marker[] = [];
  private comuniData?: ComuniFeatureCollection;
  private tooltipVisible = false;

  interventoRimodulaRichiesta: any;

  showStoricoIntervento: boolean = false;
  showStoricoLiquidazioni: boolean = false;
  showModificaNoteIntervento: boolean = false;

  showOnlyMyInterventi: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private logger: NGXLogger,
    private messageService: MessageService,
    private interventiService: InterventiService,
    private comuniService: ComuniService,
    public stiliService: StiliService,
    private excelService: ExcelService,
    private baciniService: BaciniService,
    private firebaseStorageService: FirebaseStorageService,
    private schedeService: SchedeService,
    private richiesteService: RichiesteService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    // Verifica se l'utente è un ENTE_ESECUTORE
    const ruoloUtente = localStorage.getItem('ruolo');
    this.isEnteEsecutore = ruoloUtente === 'ENTE_ESECUTORE';
    this.isAdminOrUmvs =
      ruoloUtente === 'UMVS' ||
      ruoloUtente === 'ADMIN' ||
      ruoloUtente === 'SUPERADMIN';

    // Ottieni l'ID dell'ente se l'utente è un ENTE_ESECUTORE
    if (this.isEnteEsecutore) {
      this.enteId = localStorage.getItem('enteId') || '';
      this.titoloInterventi =
        'INTERVENTI DEL ' + localStorage.getItem('enteLabel')?.toUpperCase();
    }
    this.cols = [
      { field: 'azioni', header: 'Azioni', width: '2%' },
      { field: 'richiesta', header: 'Anno', width: '3%', sortable: true },
      { field: 'scheda', header: 'Scheda', width: '6%' },
      { field: 'scheda', header: 'Vecchio codice', width: '4%' },
      { field: 'enteEsecutore', header: 'Ente Esecutore', width: '15%' },
      { field: 'bacino', header: 'Bacino', width: '15%' },
      { field: 'comune', header: 'Comune', width: '15%' },
      { field: 'stato', header: 'Stato', width: '5%' },
      { field: 'tipoIntervento', header: 'Tipo', width: '5%' },
      { field: 'priorita', header: 'Priorità', width: '1%', sortable: false },
      {
        field: 'importoRichiesto',
        header: 'Importo Richiesto',
        width: '6%',
        sortable: true,
      },
      {
        field: 'importoRimodulato',
        header: 'Importo Rimodulato',
        width: '6%',
        sortable: true,
      },
      {
        field: 'importoFinanziato',
        header: 'Importo Finanziato',
        width: '6%',
        sortable: true,
      },
      {
        field: 'importoRendicontato',
        header: 'Importo Rendicontato',
        width: '6%',
        sortable: true,
      },
      {
        field: 'importoLiquidato',
        header: 'Importo Liquidato',
        width: '6%',
        sortable: true,
      },
    ];
    this.route.queryParams.subscribe((params) => {
      if (params['codiceCatastale'] && params['denominazione']) {
        this.filtroCodiceCastale = params['codiceCatastale'];
        //this.filtri.comune = params['denominazione']
        this.titoloInterventi =
          'INTERVENTI DEL COMUNE DI ' + params['denominazione'].toUpperCase();
        /* ;
        this.filtriAttivi = true; */
        // this.caricaInterventi();
      } else if (params['consorzio']) {
        this.filtroConsorzio = params['consorzio'];
        if (params['denominazione'] == 'UMVS') {
          this.titoloInterventi =
            "INTERVENTI DELL'" + params['denominazione'].toUpperCase();
        } else {
          this.titoloInterventi =
            'INTERVENTI DEL ' + params['denominazione'].toUpperCase();
        }
        //this.titoloInterventi = "INTERVENTI DEL ";
      } else if (params['scheda']) {
        this.logger.info('[INTERVENTI] Filtro scheda', params['codice']);
        this.filtroScheda = params['scheda'];
        this.filtroCodiceScheda = params['codice'];
        this.titoloInterventi = 'INTERVENTI DELLA SCHEDA ';
      } else {
        // this.filtroAnno = params['anno']? params['anno'] : null;
        this.filtroRichiestaId = params['richiestaId']
          ? params['richiestaId']
          : null;
        //this.logger.info('[INTERVENTI] FILTRO RICHIESTA ID', this.filtroRichiestaId);
      }
    });

    this.caricaRichieste();
    this.caricaStatiIntervento();
    this.caricaInterventi();
  }

  caricaRichieste(): void {
    this.logger.info(
      '[INTERVENTI] Caricamento richieste per ente? ' + this.isEnteEsecutore,
    );
    let ente = this.enteId;
    if (!this.isEnteEsecutore) {
      ente = '34';
    }

    this.richiesteService.getRichiesteByEnte(ente).subscribe({
      next: (data) => {
        // Utilizzo un Map per tenere traccia delle richieste per anno
        const richiestePerAnno = new Map<number, Richiesta>();

        // Per ogni richiesta, la aggiungo alla mappa usando l'anno come chiave
        data.forEach((richiesta) => {
          richiestePerAnno.set(richiesta.anno, richiesta);
        });

        // Converto la mappa in array e ordino per anno decrescente (più recente prima)
        this.richieste = Array.from(richiestePerAnno.values()).sort(
          (a, b) => b.anno - a.anno,
        );

        // Crea la lista con opzione "Rimuovi filtro" alla fine
        // Usiamo un valore speciale per anno che verrà gestito nel template
        this.richiesteConRimuovi = [
          ...this.richieste,
          {
            anno: 'Tutti gli anni',
            id: 'remove-filter',
            isRemoveOption: true,
          } as any,
        ];

        console.log(
          '[INTERVENTI] Richieste ordinate per anno:',
          this.richieste.map((r) => r.id + ' - ' + r.stato.descrizione),
        );

        // Se c'è un filtroRichiestaId, cerca la richiesta corrispondente e imposta l'anno nel filtro
        if (
          this.filtroRichiestaId &&
          this.interventi &&
          this.interventi.length > 0
        ) {
          const richiestaIntervento = this.interventi[0].richiesta;
          if (richiestaIntervento && richiestaIntervento.anno) {
            const richiestaCorrispondente = this.richieste.find(
              (r) => r.anno === richiestaIntervento.anno,
            );
            if (richiestaCorrispondente) {
              this.richiestaSelezionata = richiestaCorrispondente;
              this.updateFiltriAttivi(); // Aggiorna il flag per mostrare il pulsante reset filtri
              this.logger.info(
                '[INTERVENTI] Anno selezionato automaticamente nel filtro dopo caricamento richieste:',
                richiestaIntervento.anno,
              );
            }
          }
        }
      },
    });
  }

  /**
   * Aggiorna il flag filtriAttivi basandosi sui filtri correnti
   */
  updateFiltriAttivi() {
    this.filtriAttivi = !!(
      this.richiestaSelezionata ||
      this.statoSelezionato ||
      this.filtroTestoGlobale?.trim()
    );
  }

  ngAfterViewInit() {
    // Implementazione vuota per soddisfare l'interfaccia AfterViewInit
  }

  ngOnDestroy() {
    // Cleanup se necessario
    // Cleanup della mappa
    if (this.map) {
      this.rimuoviAvvisoInterventiSenzaCoordinate();
      this.map.remove();
      this.map = null;
    }
  }
  caricaStatiIntervento() {
    this.interventiService.getStatiIntervento().subscribe((stati) => {
      // Riorganizza gli stati in modo che "IN LIQUIDAZIONE",
      // "LIQUIDATO PARZIALMENTE" e "LIQUIDATO" compaiano subito dopo
      // "RENDICONTATO COMPLETAMENTE" nei filtri.
      const inLiquidazione = stati.filter(
        (s) => s.descrizione?.toUpperCase().trim() === 'IN LIQUIDAZIONE',
      );
      const liquidatoParzialmente = stati.filter(
        (s) => s.descrizione?.toUpperCase().trim() === 'LIQUIDATO PARZIALMENTE',
      );
      const liquidato = stati.filter(
        (s) => s.descrizione?.toUpperCase().trim() === 'LIQUIDATO',
      );
      const altriStati = stati.filter(
        (s) =>
          s.descrizione?.toUpperCase().trim() !== 'IN LIQUIDAZIONE' &&
          s.descrizione?.toUpperCase().trim() !== 'LIQUIDATO PARZIALMENTE' &&
          s.descrizione?.toUpperCase().trim() !== 'LIQUIDATO',
      );

      const indiceRendicontatoCompletamente = altriStati.findIndex(
        (s) =>
          s.descrizione?.toUpperCase().trim() ===
          StatoInterventoEnum.RENDICONTATO_COMPLETAMENTE,
      );

      if (indiceRendicontatoCompletamente !== -1) {
        const before = altriStati.slice(0, indiceRendicontatoCompletamente + 1);
        const after = altriStati.slice(indiceRendicontatoCompletamente + 1);
        this.statiIntervento = [
          ...before,
          ...inLiquidazione,
          ...liquidatoParzialmente,
          ...liquidato,
          ...after,
        ];
      } else {
        // fallback: mantieni l'ordine originale, mettendo in coda i tre stati
        this.statiIntervento = [
          ...altriStati,
          ...inLiquidazione,
          ...liquidatoParzialmente,
          ...liquidato,
        ];
      }

      // Crea la lista con opzione "Rimuovi filtro" alla fine
      this.statiInterventoConRimuovi = [
        ...this.statiIntervento,
        {
          id: 'remove-filter',
          descrizione: 'Tutti gli stati',
          isRemoveOption: true,
        } as any,
      ];
    });
  }
  caricaInterventi() {
    this.interventiCaricati = false;
    if (this.filtroCodiceCastale) {
      this.logger.info(
        '[INTERVENTI] Caricamento interventi per comune',
        this.filtroCodiceCastale,
      );

      this.interventiService
        .getInterventiComune(this.filtroCodiceCastale)
        .subscribe((interventi) => {
          this.interventi = interventi;
          this.interventiFiltrati = interventi;
          this.interventiOriginali = [...interventi]; // Salvo una copia degli interventi originali
          this.interventiCaricati = true;

          // Forza il change detection per assicurarsi che la tabella venga renderizzata
          this.cdr.detectChanges();

          if (this.dt) {
            // Applica l'ordinamento di default se non è già stato applicato
            if (!this.dt.multiSortMeta || this.dt.multiSortMeta.length === 0) {
              this.dt.multiSortMeta = [...this.multiSortMeta];
              this.dt.sortMultiple();
            }
          }

          // Riapplica tutti i filtri (testo, anno, stato) se presenti
          if (
            (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) ||
            this.isAnnoValido(this.richiestaSelezionata) ||
            this.isStatoValido(this.statoSelezionato)
          ) {
            this.riapplicaTuttiFiltri();
          }

          if (this.map && this.activeTabIndex === 1) {
            const interventiFiltrati = this.dt?.filteredValue || interventi;
            this.aggiornaMarkerMappa(interventiFiltrati);
          }
        });
    } else if (this.filtroRichiestaId) {
      this.logger.info(
        '[INTERVENTI] CERCO INTERVENTI PER RICHIESTA',
        this.filtroRichiestaId,
      );

      // Prima recupera la richiesta originale dal filtroRichiestaId per ottenere l'ente esecutore corretto
      let richiestaOriginale: Richiesta | null = null;

      // Cerca la richiesta nelle richieste già caricate
      if (this.richieste && this.richieste.length > 0) {
        richiestaOriginale =
          this.richieste.find((r) => r.id === Number(this.filtroRichiestaId)) ||
          null;
      }

      // Se non trovata nelle richieste caricate, carica tutte le richieste per trovare quella corretta
      if (!richiestaOriginale) {
        this.richiesteService.getRichieste().subscribe((richieste) => {
          richiestaOriginale =
            richieste.find((r) => r.id === Number(this.filtroRichiestaId)) ||
            null;
          if (richiestaOriginale) {
            this.caricaInterventiConRichiestaOriginale(richiestaOriginale);
          } else {
            this.logger.error(
              '[INTERVENTI] Richiesta non trovata con ID:',
              this.filtroRichiestaId,
            );
            // Fallback: carica gli interventi senza la richiesta originale
            this.caricaInterventiConRichiestaOriginale(null);
          }
        });
      } else {
        this.caricaInterventiConRichiestaOriginale(richiestaOriginale);
      }
    } else if (this.filtroConsorzio) {
      this.interventiService
        .getInterventiConsorzio(this.filtroConsorzio)
        .subscribe((interventi) => {
          this.interventi = interventi;
          this.interventiFiltrati = interventi;
          this.interventiOriginali = [...interventi]; // Salvo una copia degli interventi originali
          this.interventiCaricati = true;

          // Forza il change detection per assicurarsi che la tabella venga renderizzata
          this.cdr.detectChanges();

          if (this.dt) {
            // Applica l'ordinamento di default se non è già stato applicato
            if (!this.dt.multiSortMeta || this.dt.multiSortMeta.length === 0) {
              this.dt.multiSortMeta = [...this.multiSortMeta];
              this.dt.sortMultiple();
            }
          }

          // Riapplica tutti i filtri (testo, anno, stato) se presenti
          if (
            (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) ||
            this.isAnnoValido(this.richiestaSelezionata) ||
            this.isStatoValido(this.statoSelezionato)
          ) {
            this.riapplicaTuttiFiltri();
          }

          if (this.map && this.activeTabIndex === 1) {
            const interventiFiltrati = this.dt?.filteredValue || interventi;
            this.aggiornaMarkerMappa(interventiFiltrati);
          }
        });
    } else if (this.filtroScheda) {
      this.interventiService
        .getInterventiScheda(this.filtroScheda)
        .subscribe((interventi) => {
          this.interventi = interventi;
          this.interventiOriginali = [...interventi]; // Salvo una copia degli interventi originali
          this.filtriAttivi = true;
          this.interventiCaricati = true;

          // Forza il change detection per assicurarsi che la tabella venga renderizzata
          this.cdr.detectChanges();

          if (this.dt) {
            // Applica l'ordinamento di default se non è già stato applicato
            if (!this.dt.multiSortMeta || this.dt.multiSortMeta.length === 0) {
              this.dt.multiSortMeta = [...this.multiSortMeta];
              this.dt.sortMultiple();
            }
          }

          // Riapplica tutti i filtri (testo, anno, stato) se presenti
          if (
            (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) ||
            this.isAnnoValido(this.richiestaSelezionata) ||
            this.isStatoValido(this.statoSelezionato)
          ) {
            this.riapplicaTuttiFiltri();
          }

          if (this.map && this.activeTabIndex === 1) {
            const interventiFiltrati = this.dt?.filteredValue || interventi;
            this.aggiornaMarkerMappa(interventiFiltrati);
          }
        });
    } else {
      this.interventiService.getInterventi().subscribe((interventi) => {
        this.interventi = interventi;
        this.interventiFiltrati = interventi;
        this.interventiOriginali = [...interventi]; // Salvo una copia degli interventi originali

        // Forza il change detection per assicurarsi che la tabella venga renderizzata
        this.cdr.detectChanges();

        if (this.dt) {
          // Applica l'ordinamento di default se non è già stato applicato
          if (!this.dt.multiSortMeta || this.dt.multiSortMeta.length === 0) {
            this.dt.multiSortMeta = [...this.multiSortMeta];
            this.dt.sortMultiple();
          }

          // Applica tutti i filtri
          if (this.filtroTestoGlobale) {
            this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
          }
          if (this.isAnnoValido(this.richiestaSelezionata)) {
            this.dt.filter(
              (this.richiestaSelezionata as any).anno,
              'richiesta.anno',
              'equals',
            );
          }
          if (
            this.isStatoValido(this.statoSelezionato) &&
            this.statoSelezionato
          ) {
            this.dt.filter(
              this.statoSelezionato.descrizione,
              'stato.descrizione',
              'equals',
            );
          }
          if (this.filtri.bacino) {
            this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
          }
          if (this.filtri.comune) {
            this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
          }
        } else {
          // Se la tabella non è ancora disponibile, riapplica tutti i filtri dopo il rendering
          if (
            (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) ||
            this.isAnnoValido(this.richiestaSelezionata) ||
            this.isStatoValido(this.statoSelezionato)
          ) {
            this.riapplicaTuttiFiltri();
          }
        }

        this.interventiCaricati = true;
        if (this.map && this.activeTabIndex === 1) {
          const interventiFiltrati = this.dt?.filteredValue || interventi;
          this.aggiornaMarkerMappa(interventiFiltrati);
        }
      });
    }
  }

  /**
   * Carica gli interventi per una richiesta usando la richiesta originale per ottenere l'ente esecutore corretto
   */
  private caricaInterventiConRichiestaOriginale(
    richiestaOriginale: Richiesta | null,
  ) {
    if (!this.filtroRichiestaId) return;

    this.interventiService
      .getInterventiRichiesta(this.filtroRichiestaId)
      .subscribe((interventi) => {
        // Usa la richiesta originale passata nel query parameter invece di quella del primo intervento
        const richiesta =
          richiestaOriginale ||
          (interventi && interventi.length > 0
            ? interventi[0].richiesta
            : null);

        if (richiesta) {
          this.logger.info('[INTERVENTI] Interventi recuperati:', interventi);
          this.logger.info(
            '[INTERVENTI] Richiesta originale utilizzata:',
            richiesta,
          );

          if (richiesta.enteEsecutore?.id) {
            this.enteIdRichiesta = String(richiesta.enteEsecutore.id);
            this.logger.info(
              '[INTERVENTI] Ente della richiesta originale recuperato:',
              this.enteIdRichiesta,
            );
          }

          // Aggiorna il titolo con anno e ente della richiesta originale
          if (richiesta.anno && richiesta.enteEsecutore?.label) {
            this.titoloInterventi = `INTERVENTI ${richiesta.enteEsecutore.label.toUpperCase()} ${richiesta.anno}`;
            this.logger.info(
              '[INTERVENTI] Titolo aggiornato con richiesta originale:',
              this.titoloInterventi,
            );
          }

          // Seleziona automaticamente l'anno corrispondente nel filtro
          // Se le richieste sono già caricate, imposta subito la selezione
          if (richiesta.anno && this.richieste && this.richieste.length > 0) {
            const richiestaCorrispondente = this.richieste.find(
              (r) =>
                r.anno === richiesta.anno &&
                r.enteEsecutore?.id === richiesta.enteEsecutore?.id,
            );
            if (richiestaCorrispondente) {
              this.richiestaSelezionata = richiestaCorrispondente;
              this.updateFiltriAttivi(); // Aggiorna il flag per mostrare il pulsante reset filtri
              this.logger.info(
                '[INTERVENTI] Anno selezionato automaticamente nel filtro:',
                richiesta.anno,
              );
            }
          }
          // Se le richieste non sono ancora caricate, verrà impostato quando caricaRichieste() completa
        }

        this.interventi = interventi;
        this.interventiFiltrati = interventi;
        this.interventiOriginali = [...interventi]; // Salvo una copia degli interventi originali

        // Applica il filtro per ente se attivo
        if (this.mostraSoloInterventiEnteRichiesta && this.enteIdRichiesta) {
          this.applicaFiltroEnteRichiesta();
        }

        this.interventiCaricati = true;

        // Forza il change detection per assicurarsi che la tabella venga renderizzata
        this.cdr.detectChanges();

        if (this.dt) {
          // Applica l'ordinamento di default se non è già stato applicato
          if (!this.dt.multiSortMeta || this.dt.multiSortMeta.length === 0) {
            this.dt.multiSortMeta = [...this.multiSortMeta];
            this.dt.sortMultiple();
          }
        }

        // Riapplica tutti i filtri (testo, anno, stato) se presenti
        if (
          (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) ||
          this.isAnnoValido(this.richiestaSelezionata) ||
          this.isStatoValido(this.statoSelezionato)
        ) {
          this.riapplicaTuttiFiltri();
        }

        if (this.map && this.activeTabIndex === 1) {
          const interventiFiltrati =
            this.dt?.filteredValue || this.interventiFiltrati;
          this.aggiornaMarkerMappa(interventiFiltrati);
        }
      });
  }

  private pulisciMarker() {
    if (this.markers.length > 0) {
      //this.logger.info('[INTERVENTI] Pulizia marker esistenti', this.markers.length);
      this.markers.forEach((marker) => marker.remove());
      this.markers = [];
    }
  }

  private aggiornaMarkerMappa(interventi: any[]) {
    if (!this.map) {
      //this.logger.warn('[INTERVENTI] Mappa non ancora inizializzata, impossibile aggiornare i marker');
      return;
    }

    //this.logger.info('[INTERVENTI] Aggiornamento marker mappa', interventi.length);

    // Pulisci i marker esistenti
    this.pulisciMarker();

    // Conta interventi senza coordinate
    const interventiSenzaCoordinate = interventi.filter(
      (intervento) => !intervento.latitudine || !intervento.longitudine,
    ).length;

    // Mostra avviso se ci sono interventi senza coordinate
    if (interventiSenzaCoordinate > 0) {
      this.mostraAvvisoInterventiSenzaCoordinate(interventiSenzaCoordinate);
    } else {
      this.rimuoviAvvisoInterventiSenzaCoordinate();
    }

    // Raggruppa gli interventi per coordinate
    const interventiPerCoordinate = new Map<string, any[]>();

    interventi.forEach((intervento) => {
      if (intervento.latitudine && intervento.longitudine) {
        const key = `${intervento.latitudine},${intervento.longitudine}`;
        if (!interventiPerCoordinate.has(key)) {
          interventiPerCoordinate.set(key, []);
        }
        interventiPerCoordinate.get(key)?.push(intervento);
      }
    });

    // Aggiungi i marker per ogni gruppo di coordinate
    interventiPerCoordinate.forEach((interventiGruppo, coordinate) => {
      try {
        const [lat, lng] = coordinate.split(',').map(Number);
        const colore = this.stiliService.getColoreAnnoRichiesta(
          interventiGruppo[0].richiesta,
        );

        // Se c'è un solo intervento, usa il marker standard
        if (interventiGruppo.length === 1) {
          const intervento = interventiGruppo[0];
          const isMioIntervento = this.isInterventoDellEnte(intervento);
          const markerColore = isMioIntervento ? colore : '#F09D51';
          const enteLabel = intervento.richiesta?.enteEsecutore?.label || 'N/A';
          const enteStyle = isMioIntervento
            ? `color: ${markerColore}`
            : 'color: #F09D51; font-weight: 600;';

          const marker = new maplibregl.Marker({
            color: markerColore,
          })
            .setLngLat([lng, lat])
            .addTo(this.map as any);

          // Crea il contenuto del tooltip
          const tooltipContent = `
            <div style="padding: 8px; min-width: 250px;">
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                ${
                  intervento.scheda?.vecchioCodiceUmvs
                    ? `
                  <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #8f5cb7; min-width: 60px;">
                    <span style="color: #8B4513; font-weight: bold; font-size: 11px;">${intervento.scheda.vecchioCodiceUmvs}</span>
                  </div>
                `
                    : ''
                }
                <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #4285F4; min-width: 60px;">
                  <span style="color: #3a6e75; font-weight: bold; font-size: 11px;">${intervento.scheda?.codice || 'Intervento'}</span>
                </div>
              </div>
              <br>
              <div style="padding: 0 8px;">
                Ente: <span style="font-size: 14px; ${enteStyle}">${enteLabel}</span><br>
                Anno: <span style="font-size: 14px; color: ${markerColore}">${intervento.richiesta?.anno || 0}</span><br>
                Importo richiesto: <span style="font-size: 14px; color: ${markerColore}"><strong>${intervento.importoRichiesto || 0} €</strong></span>
              </div>
            </div>
          `;

          // Aggiungi il tooltip al marker
          const tooltip = new maplibregl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: 25,
            maxWidth: '300px',
            className: 'custom-popup',
          }).setHTML(tooltipContent);

          // Gestisci gli eventi del mouse
          marker.getElement().addEventListener('mouseenter', () => {
            tooltip.setLngLat([lng, lat]).addTo(this.map as any);
          });

          marker.getElement().addEventListener('mouseleave', () => {
            tooltip.remove();
          });

          this.markers.push(marker);
        } else {
          // Per due o più interventi, usa il marker raggruppato
          // Controlla se ci sono interventi di altri enti nel gruppo
          const hasOtherEnti = interventiGruppo.some(
            (intervento) => !this.isInterventoDellEnte(intervento),
          );
          const clusterColore = hasOtherEnti ? '#F09D51' : colore;
          const clusterBorder = hasOtherEnti ? '#E67E22' : 'white';

          const tooltipContent = `
            <div style="padding: 8px; min-width: 280px;">
              <div style="display: flex; align-items: center; background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-left: 4px solid ${clusterColore}; border-radius: 4px; padding: 8px 12px; margin: 0 auto; box-shadow: 0 2px 4px rgba(0,0,0,0.05); max-width: fit-content; transition: all 0.2s ease;">
                <span style="color: #333; font-weight: 600; font-size: 13px; letter-spacing: 0.5px;">${interventiGruppo.length} interventi</span>
                ${hasOtherEnti ? '<span style="margin-left: 8px; font-size: 11px; color: #F09D51; font-weight: 600;">MISTI</span>' : ''}
              </div>
              <br>
              ${interventiGruppo
                .map((intervento) => {
                  const isMioIntervento = this.isInterventoDellEnte(intervento);
                  const enteLabel =
                    intervento.richiesta?.enteEsecutore?.label || 'N/A';
                  const enteStyle = isMioIntervento
                    ? `color: ${this.stiliService.getColoreAnnoRichiesta(intervento.richiesta)}`
                    : 'color: #F09D51; font-weight: 600;';
                  return `
                  <div style="margin-bottom: 10px;">
                    <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                      ${
                        intervento.scheda?.vecchioCodiceUmvs
                          ? `
                        <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #8f5cb7; min-width: 60px;">
                          <span style="color: #8B4513; font-weight: bold; font-size: 11px;">${intervento.scheda.vecchioCodiceUmvs}</span>
                        </div>
                      `
                          : ''
                      }
                      <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #4285F4; min-width: 60px;">
                        <span style="color: #3a6e75; font-weight: bold; font-size: 11px;">${intervento.scheda?.codice || 'Intervento'}</span>
                      </div>
                    </div>
                    Ente: <span style="font-size: 13px; ${enteStyle}">${enteLabel}</span><br>
                    Anno: <span style="font-size: 14px; color: ${this.stiliService.getColoreAnnoRichiesta(intervento.richiesta)}">${intervento.richiesta?.anno || 0}</span><br>
                    Importo: <span style="font-size: 14px;"><strong>${intervento.importoRichiesto || 0} €</strong></span>
                  </div>
                `;
                })
                .join(
                  '<hr style="margin: 8px 0; border: none; border-top: 1px solid #eee;">',
                )}
            </div>
          `;

          const el = document.createElement('div');
          el.className = 'marker-cluster';
          el.innerHTML = `
            <div style="
              background-color: ${clusterColore};
              color: white;
              border-radius: 50%;
              width: 30px;
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 14px;
              border: 2px solid ${clusterBorder};
              box-shadow: 0 2px 4px rgba(0,0,0,0.2);
              cursor: pointer;
            ">
              ${interventiGruppo.length}
            </div>
          `;

          const marker = new maplibregl.Marker({
            element: el,
          })
            .setLngLat([lng, lat])
            .addTo(this.map as any);

          const tooltip = new maplibregl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: 25,
            maxWidth: '600px',
            className: 'custom-popup',
          }).setHTML(tooltipContent);

          // Gestisci gli eventi del mouse
          marker.getElement().addEventListener('mouseenter', () => {
            tooltip.setLngLat([lng, lat]).addTo(this.map as any);
          });

          marker.getElement().addEventListener('mouseleave', () => {
            tooltip.remove();
          });

          // Gestisci il click sul marker raggruppato
          marker.getElement().addEventListener('click', () => {
            // Rimuovi il marker raggruppato
            marker.remove();

            // Chiudi il tooltip se è aperto
            tooltip.remove();

            // Aggiungi i singoli marker con un offset più significativo
            interventiGruppo.forEach((intervento, index) => {
              // Calcola un offset circolare per distribuire i marker
              const angle = (index / interventiGruppo.length) * 2 * Math.PI;
              const radius = 0.0005; // Aumentato il raggio per una distribuzione più ampia
              const offsetLng = lng + radius * Math.cos(angle);
              const offsetLat = lat + radius * Math.sin(angle);

              const isMioIntervento = this.isInterventoDellEnte(intervento);
              const markerColore = isMioIntervento
                ? this.stiliService.getColoreAnnoRichiesta(intervento.richiesta)
                : '#F09D51';
              const enteLabel =
                intervento.richiesta?.enteEsecutore?.label || 'N/A';

              const singleMarker = new maplibregl.Marker({
                color: markerColore,
              })
                .setLngLat([offsetLng, offsetLat])
                .setPopup(
                  new maplibregl.Popup({
                    offset: 25,
                    closeButton: true,
                    closeOnClick: true,
                    maxWidth: '280px',
                  }).setHTML(`
                  <div style="padding: 12px; min-width: 220px;">
                    <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 12px;">
                      ${
                        intervento.scheda?.vecchioCodiceUmvs
                          ? `
                        <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #8f5cb7; min-width: 60px;">
                          <span style="color: #8B4513; font-weight: bold; font-size: 11px;">${intervento.scheda.vecchioCodiceUmvs}</span>
                        </div>
                      `
                          : ''
                      }
                      <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #4285F4; min-width: 60px;">
                        <span style="color: #3a6e75; font-weight: bold; font-size: 11px;">${intervento.scheda?.codice || 'Intervento'}</span>
                      </div>
                    </div>
                    <p style="margin: 6px 0;"><strong>Ente:</strong> <span style="color: ${isMioIntervento ? markerColore : '#F09D51'}; font-weight: ${isMioIntervento ? 'normal' : '600'};">${enteLabel}</span></p>
                    <p style="margin: 6px 0;"><strong>Anno:</strong> ${intervento.richiesta?.anno || 0}</p>
                    <p style="margin: 6px 0;"><strong>Importo:</strong> ${intervento.importoRichiesto || 0}€</p>
                    <p style="margin: 6px 0;"><strong>Stato:</strong> ${intervento.stato?.descrizione || 'N/A'}</p>
                  </div>
                `),
                )
                .addTo(this.map as any);

              // Aggiungi il tooltip al marker singolo
              const singleTooltip = new maplibregl.Popup({
                closeButton: false,
                closeOnClick: false,
                offset: 25,
                maxWidth: '500px',
              }).setHTML(`
                <div style="padding: 8px; min-width: 250px;">
                  <div style="display: flex; align-items: center; gap: 0.5rem;">
                    ${
                      intervento.scheda?.vecchioCodiceUmvs
                        ? `
                      <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #8f5cb7; min-width: 60px;">
                        <span style="color: #8B4513; font-weight: bold; font-size: 11px;">${intervento.scheda.vecchioCodiceUmvs}</span>
                      </div>
                    `
                        : ''
                    }
                    <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #4285F4; min-width: 60px;">
                      <span style="color: #3a6e75; font-weight: bold; font-size: 11px;">${intervento.scheda?.codice || 'Intervento'}</span>
                    </div>
                  </div>
                  <br>
                  Ente: <span style="font-size: 14px; ${isMioIntervento ? `color: ${markerColore}` : 'color: #F09D51'}; font-weight: ${isMioIntervento ? 'normal' : '600'};">${enteLabel}</span><br>
                  Anno: <span style="font-size: 14px; color: ${markerColore}">${intervento.richiesta?.anno || 0}</span><br>
                  Importo richiesto: <span style="font-size: 14px;"><strong>${intervento.importoRichiesto || 0} €</strong></span>
                </div>
              `);

              singleMarker.getElement().addEventListener('mouseenter', () => {
                singleTooltip
                  .setLngLat([offsetLng, offsetLat])
                  .addTo(this.map as any);
              });

              singleMarker.getElement().addEventListener('mouseleave', () => {
                singleTooltip.remove();
              });

              this.markers.push(singleMarker);
            });

            // Rimuovi il marker raggruppato dall'array
            const index = this.markers.indexOf(marker);
            if (index > -1) {
              this.markers.splice(index, 1);
            }

            // Zoom leggermente sulla zona per mostrare meglio i marker
            if (this.map) {
              const bounds = new maplibregl.LngLatBounds();
              interventiGruppo.forEach((_, index) => {
                const angle = (index / interventiGruppo.length) * 2 * Math.PI;
                const radius = 0.0005;
                const offsetLng = lng + radius * Math.cos(angle);
                const offsetLat = lat + radius * Math.sin(angle);
                bounds.extend([offsetLng, offsetLat]);
              });

              (this.map as any).fitBounds(bounds, {
                padding: 20,
                duration: 500,
                maxZoom: 15,
              });
            }
          });

          this.markers.push(marker);
        }
      } catch (error) {
        this.logger.error(
          "[INTERVENTI] Errore nell'aggiunta del marker",
          error,
        );
      }
    });
  }

  onFiltroGlobaleChange(event: any) {
    // Aggiorna flag filtri attivi
    this.updateFiltriAttivi();

    if (this.dt) {
      this.dt.filterGlobal(event.target.value, 'contains');
      // Aggiorna la mappa se siamo nella tab della mappa
      if (this.map && this.activeTabIndex === 1) {
        const interventiFiltrati = this.dt.filteredValue || this.interventi;
        this.aggiornaMarkerMappa(interventiFiltrati);
      }
    }
  }

  onFilter(event: any) {
    this.interventiFiltrati = event.filteredValue || [];
    if (this.map && this.activeTabIndex === 1) {
      this.aggiornaMarkerMappa(this.interventiFiltrati);
    }
  }

  pulisciFiltroGlobale() {
    this.filtroTestoGlobale = '';
    // Aggiorna flag filtri attivi
    this.updateFiltriAttivi();

    if (this.dt) {
      this.dt.filterGlobal('', 'contains');
      // Aggiorna i marker dopo la pulizia del filtro
      this.interventiFiltrati = this.dt.filteredValue || this.interventi;
      if (this.map && this.activeTabIndex === 1) {
        this.aggiornaMarkerMappa(this.interventiFiltrati);
      }
    }
  }

  /**
   * Riapplica il filtro di testo globale dopo il caricamento dei dati
   * Usa un approccio con retry per assicurarsi che la tabella sia renderizzata
   */
  riapplicaFiltroTestoGlobale(): void {
    if (!this.filtroTestoGlobale || this.filtroTestoGlobale.length === 0) {
      return;
    }

    // Funzione helper per provare ad applicare il filtro
    const applicaFiltro = (tentativo: number = 0) => {
      const maxTentativi = 20; // Aumentato il numero di tentativi

      // Verifica più accurata: la tabella deve esistere, avere dati e essere renderizzata
      if (
        this.dt &&
        this.interventiCaricati &&
        this.interventi &&
        this.interventi.length > 0 &&
        typeof this.dt.filterGlobal === 'function'
      ) {
        try {
          // La tabella è disponibile e renderizzata
          this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
          // Aggiorna anche gli interventi filtrati
          this.interventiFiltrati = this.dt.filteredValue || this.interventi;
          // Aggiorna la mappa se siamo nella tab della mappa
          if (this.map && this.activeTabIndex === 1) {
            this.aggiornaMarkerMappa(this.interventiFiltrati);
          }
          console.log(
            `[INTERVENTI] Filtro di testo globale riapplicato: "${this.filtroTestoGlobale}"`,
          );
        } catch (error) {
          console.warn(
            "[INTERVENTI] Errore nell'applicazione del filtro:",
            error,
          );
          // Riprova se c'è un errore
          if (tentativo < maxTentativi) {
            setTimeout(() => {
              applicaFiltro(tentativo + 1);
            }, 100);
          }
        }
      } else if (tentativo < maxTentativi) {
        // La tabella non è ancora disponibile, riprova dopo un breve delay
        setTimeout(() => {
          // Forza il change detection prima di riprovare
          this.cdr.detectChanges();
          applicaFiltro(tentativo + 1);
        }, 100);
      } else {
        console.warn(
          '[INTERVENTI] Impossibile riapplicare il filtro di testo globale: tabella non disponibile dopo',
          maxTentativi,
          'tentativi',
        );
      }
    };

    // Inizia il tentativo di applicazione del filtro
    // Usa un doppio requestAnimationFrame per assicurarsi che il DOM sia completamente aggiornato
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        applicaFiltro();
      });
    });
  }

  /**
   * Applica il filtro per mostrare/nascondere interventi di altri enti quando si arriva da una richiesta
   */
  applicaFiltroEnteRichiesta(): void {
    if (
      !this.enteIdRichiesta ||
      !this.interventiOriginali ||
      this.interventiOriginali.length === 0
    ) {
      return;
    }

    if (this.mostraSoloInterventiEnteRichiesta) {
      // Mostra solo gli interventi dell'ente della richiesta
      this.interventi = this.interventiOriginali.filter(
        (intervento) =>
          String(intervento.richiesta?.enteEsecutore?.id) ===
          this.enteIdRichiesta,
      );
    } else {
      // Mostra tutti gli interventi
      this.interventi = [...this.interventiOriginali];
    }

    this.interventiFiltrati = [...this.interventi];

    // Aggiorna la tabella se disponibile
    if (this.dt) {
      this.dt.value = this.interventi;
      // Riapplica gli altri filtri se presenti (senza chiamare riapplicaTuttiFiltri per evitare loop)
      if (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) {
        this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
      }
      if (this.isAnnoValido(this.richiestaSelezionata)) {
        this.dt.filter(
          (this.richiestaSelezionata as any).anno,
          'richiesta.anno',
          'equals',
        );
      }
      if (this.isStatoValido(this.statoSelezionato) && this.statoSelezionato) {
        this.dt.filter(
          this.statoSelezionato.descrizione,
          'stato.descrizione',
          'equals',
        );
      }
      // Aggiorna gli interventi filtrati dopo aver applicato i filtri della tabella
      this.interventiFiltrati = this.dt.filteredValue || this.interventi;
    }

    // Aggiorna la mappa se siamo nella tab della mappa
    if (this.map && this.activeTabIndex === 1) {
      this.aggiornaMarkerMappa(this.interventiFiltrati);
    }
  }

  /**
   * Gestisce il cambio del toggle per mostrare/nascondere interventi di altri enti
   */
  onToggleFiltroEnteRichiesta(): void {
    // Assicurati che il valore sia sincronizzato
    setTimeout(() => {
      this.applicaFiltroEnteRichiesta();
      this.logger.info(
        '[INTERVENTI] Toggle filtro ente richiesta:',
        this.mostraSoloInterventiEnteRichiesta,
      );
    }, 0);
  }

  /**
   * Riapplica tutti i filtri (testo globale, anno, stato) dopo il caricamento dei dati
   * Usa un approccio con retry per assicurarsi che la tabella sia renderizzata
   */
  riapplicaTuttiFiltri(): void {
    // Funzione helper per provare ad applicare i filtri
    const applicaFiltri = (tentativo: number = 0) => {
      const maxTentativi = 20;

      // Verifica più accurata: la tabella deve esistere, avere dati e essere renderizzata
      if (
        this.dt &&
        this.interventiCaricati &&
        this.interventi &&
        this.interventi.length > 0 &&
        typeof this.dt.filterGlobal === 'function'
      ) {
        try {
          // Applica l'ordinamento di default se non è già stato applicato
          if (!this.dt.multiSortMeta || this.dt.multiSortMeta.length === 0) {
            this.dt.multiSortMeta = [...this.multiSortMeta];
            this.dt.sortMultiple();
          }

          // Riapplica il filtro di testo globale se presente
          if (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) {
            this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
          }

          // Riapplica il filtro anno se presente
          if (this.isAnnoValido(this.richiestaSelezionata)) {
            this.dt.filter(
              (this.richiestaSelezionata as any).anno,
              'richiesta.anno',
              'equals',
            );
          }

          // Riapplica il filtro stato se presente
          if (
            this.isStatoValido(this.statoSelezionato) &&
            this.statoSelezionato
          ) {
            this.dt.filter(
              this.statoSelezionato.descrizione,
              'stato.descrizione',
              'equals',
            );
          }

          // Riapplica altri filtri se presenti
          if (this.filtri.bacino) {
            this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
          }
          if (this.filtri.comune) {
            this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
          }

          // Applica il filtro ente richiesta se attivo e siamo arrivati da una richiesta
          if (
            this.filtroRichiestaId &&
            this.mostraSoloInterventiEnteRichiesta &&
            this.enteIdRichiesta
          ) {
            // Filtra gli interventi filtrati per ente richiesta
            const interventiFiltratiPerEnte = (
              this.dt.filteredValue || this.interventi
            ).filter(
              (intervento) =>
                String(intervento.richiesta?.enteEsecutore?.id) ===
                this.enteIdRichiesta,
            );
            this.interventiFiltrati = interventiFiltratiPerEnte;
          } else {
            // Aggiorna anche gli interventi filtrati
            this.interventiFiltrati = this.dt.filteredValue || this.interventi;
          }

          // Aggiorna la mappa se siamo nella tab della mappa
          if (this.map && this.activeTabIndex === 1) {
            this.aggiornaMarkerMappa(this.interventiFiltrati);
          }

          console.log(
            `[INTERVENTI] Tutti i filtri riapplicati: testo="${this.filtroTestoGlobale}", anno=${this.isAnnoValido(this.richiestaSelezionata) ? (this.richiestaSelezionata as any).anno : 'nessuno'}, stato=${this.isStatoValido(this.statoSelezionato) && this.statoSelezionato ? this.statoSelezionato.descrizione : 'nessuno'}, enteRichiesta=${this.mostraSoloInterventiEnteRichiesta}`,
          );
        } catch (error) {
          console.warn(
            "[INTERVENTI] Errore nell'applicazione dei filtri:",
            error,
          );
          // Riprova se c'è un errore
          if (tentativo < maxTentativi) {
            setTimeout(() => {
              applicaFiltri(tentativo + 1);
            }, 100);
          }
        }
      } else if (tentativo < maxTentativi) {
        // La tabella non è ancora disponibile, riprova dopo un breve delay
        setTimeout(() => {
          // Forza il change detection prima di riprovare
          this.cdr.detectChanges();
          applicaFiltri(tentativo + 1);
        }, 100);
      } else {
        console.warn(
          '[INTERVENTI] Impossibile riapplicare i filtri: tabella non disponibile dopo',
          maxTentativi,
          'tentativi',
        );
      }
    };

    // Inizia il tentativo di applicazione dei filtri
    // Usa un doppio requestAnimationFrame per assicurarsi che il DOM sia completamente aggiornato
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        applicaFiltri();
      });
    });
  }

  /**
   * Metodo per aggiornare gli interventi mantenendo i filtri attivi
   * Usa i valori correnti dei filtri e riapplica il filtro di testo globale
   */
  aggiornaInterventi(): void {
    // Carica gli interventi con i filtri correnti
    // Il metodo caricaInterventi riapplicherà automaticamente il filtro di testo globale
    this.caricaInterventi();
  }

  azzeraTuttiFiltri() {
    this.filtri = {
      bacino: null,
      comune: null,
      anno: null,
    };
    this.filtriAttivi = false;
    this.filtroAnno = null;
    this.filtroScheda = null;
    this.filtroConsorzio = null;
    this.filtroTestoGlobale = '';
    this.filtroCodiceScheda = null;
    // Reset filtri inline
    this.richiestaSelezionata = null;
    this.statoSelezionato = null;

    // Se c'è un filtroRichiestaId, rimuovilo e ricarica tutti i dati
    const avevaRichiestaId = !!this.filtroRichiestaId;
    if (this.filtroRichiestaId) {
      this.filtroRichiestaId = null;
      // Mantieni enteIdRichiesta solo se l'utente è ADMIN/SUPERADMIN/UMVS (per permettere il toggle anche dopo aver rimosso i filtri)
      if (!this.isAdminOrUmvs) {
        this.enteIdRichiesta = null;
        this.mostraSoloInterventiEnteRichiesta = false;
      } else {
        // Per ADMIN/SUPERADMIN/UMVS, mantieni enteIdRichiesta ma resetta il toggle
        this.mostraSoloInterventiEnteRichiesta = false;
      }
    }

    // Se c'era un richiestaId, ricarica tutti i dati senza filtro
    if (avevaRichiestaId) {
      // Reset tabella
      if (this.dt) {
        this.dt.reset();
        this.dt.clear();
      }

      // Ricarica tutti gli interventi senza filtro richiesta
      this.caricaInterventi();

      // Aggiorna il titolo
      if (this.isEnteEsecutore) {
        this.titoloInterventi =
          'INTERVENTI DEL ' + localStorage.getItem('enteLabel')?.toUpperCase();
      } else {
        this.titoloInterventi = 'INTERVENTI';
      }

      // Rimuovi il richiestaId dai query params
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
        replaceUrl: true,
      });

      return; // Esci dal metodo, caricaInterventi() gestirà il resto
    }

    // Ripristina i dati originali senza ricaricare dalle API (caso normale senza richiestaId)
    if (this.interventiOriginali && this.interventiOriginali.length > 0) {
      this.interventi = [...this.interventiOriginali];
      this.interventiFiltrati = [...this.interventiOriginali];
    }

    // Reset tabella
    if (this.dt) {
      this.dt.reset();
      this.dt.clear();

      // Applica l'ordinamento di default dopo il reset
      setTimeout(() => {
        if (
          this.dt &&
          (!this.dt.multiSortMeta || this.dt.multiSortMeta.length === 0)
        ) {
          this.dt.multiSortMeta = [...this.multiSortMeta];
          this.dt.sortMultiple();
        }
      }, 100);
    }

    if (this.isEnteEsecutore) {
      this.titoloInterventi =
        'INTERVENTI DEL ' + localStorage.getItem('enteLabel')?.toUpperCase();
    } else {
      this.titoloInterventi = 'INTERVENTI';
    }

    // Aggiorna l'URL senza ricaricare i dati (caso normale senza richiestaId)
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true, // Sostituisce l'URL corrente nella cronologia del browser
    });

    // Aggiorna la mappa se siamo nella tab della mappa
    if (this.map && this.activeTabIndex === 1) {
      this.aggiornaMarkerMappa(this.interventiFiltrati);
    }
  }

  openCaricaAzioni(event: any, intervento: any): Promise<void> {
    this.selectedIntervento = intervento;
    this.loadAzioni(event, intervento);
    this.azioniMenuTiered.toggle(event);
    return Promise.resolve();
  }

  checkIfSameEnteEsecutore(intervento: Intervento): boolean {
    if (!this.isEnteEsecutore) {
      return true;
    }
    return (
      String(intervento.richiesta?.enteEsecutore?.id) === String(this.enteId)
    );
  }

  loadAzioni(event: any, intervento: any) {
    this.menuAzioniItems = [
      /*  {
        label: "Storico",
        icon: PrimeIcons.HISTORY,
        style: {
          'font-size': '12px'
        },
        items: [
          {
            label: "Storico intervento",
            icon: PrimeIcons.HISTORY,
            style: {
              'font-size': '12px'
            },
            command: () => this.mostraStoricoIntervento(intervento),
          },

        ]
      }, */
      {
        label: 'Mostra su mappa',
        icon: PrimeIcons.MAP_MARKER,
        style: { 'font-size': '12px' },
        command: () => this.mostraInterventoSuMappa(intervento),
      },
      {
        label: 'Storico',
        icon: PrimeIcons.HISTORY,
        style: {
          'font-size': '12px',
        },
        command: () => this.mostraStoricoIntervento(intervento),
      },
      {
        label: 'Modifica note',
        icon: PrimeIcons.FILE_EDIT,
        style: {
          'font-size': '12px',
          'font-weight': 'bold',
        },
        command: () => this.modificaNoteIntervento(intervento),
      },
    ];

    if (
      !this.isEnteEsecutore &&
      intervento.stato.descrizione.toUpperCase() == 'DA FINANZIARE'
    ) {
      /*  this.menuAzioniItems.push(
        {
          label: "Comunica contributo",
          icon: PrimeIcons.MONEY_BILL,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          command: () => this.comunicaContributo(intervento),
        },
      ); */
    }
    if (
      this.isEnteEsecutore &&
      intervento.richiesta.stato.descrizione.toUpperCase() == 'DA FINANZIARE' &&
      intervento.stato.descrizione.toUpperCase() == 'DA FINANZIARE'
    ) {
      this.menuAzioniItems.push({
        label: 'Modifica rimodulato',
        icon: PrimeIcons.CALCULATOR,
        style: {
          'font-size': '12px',
          'font-weight': 'bold',
        },
        command: () => this.rimodulaRichiesta(intervento),
      });
    }

    if (intervento.stato.descrizione.toUpperCase() == 'DA RIMODULARE') {
      // this.logger.info('[INTERVENTI] Rimodula intervento su ente ', intervento.richiesta?.enteEsecutore?.id + " " + this.enteId);
      //if(this.isEnteEsecutore || (!this.isEnteEsecutore && intervento.richiesta?.enteEsecutore?.id == this.enteId)){
      this.menuAzioniItems.push({
        label: 'Rimodula',
        icon: PrimeIcons.CALCULATOR,
        style: {
          'font-size': '12px',
          'font-weight': 'bold',
        },
        command: () => this.rimodulaRichiesta(intervento),
      });
      // }
    }
    /*  if( intervento.stato.descrizione.toUpperCase() == "DA FINANZIARE" &&
    (intervento.importoRimodulato && intervento.importoRimodulato > 0)){
      this.menuAzioniItems.push(
        {
          label: "Modifica rimodulato",
          icon: PrimeIcons.CALCULATOR,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          command: () => this.rimodulaRichiesta(intervento),
        },
      );
    } */

    if (
      !this.isEnteEsecutore &&
      intervento.stato.descrizione.toUpperCase() == 'DA FINANZIARE'
    ) {
      this.menuAzioniItems.push({
        label: 'Finanzia',
        icon: PrimeIcons.MONEY_BILL,
        style: {
          'font-size': '12px',
          'font-weight': 'bold',
        },
        command: () => this.finanziaIntervento(intervento),
      });
    }

    /* if(intervento.stato.descrizione.toUpperCase() == "FINANZIATO"){
      this.menuAzioniItems.push(
        {
          label: "Rivedi richiesta",
          icon: PrimeIcons.CALCULATOR,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          command: () => this.rivediImportoIntervento(intervento),
        },
      );
    } */
    if (
      intervento.stato.descrizione.toUpperCase() == 'FINANZIATO' ||
      intervento.stato.descrizione.toUpperCase() ==
        'RENDICONTATO PARZIALMENTE' ||
      intervento.stato.descrizione.toUpperCase() == 'LIQUIDATO PARZIALMENTE'
    ) {
      let itemRendiconta = [];

      if (
        intervento.importoRendicontato &&
        intervento.importoRendicontato > 0
      ) {
        itemRendiconta.push(
          /*  {
            label: "Scarica doc",
            icon: PrimeIcons.FILE_PDF,
            style: {
              'font-size': '12px',
            },
            command: () => this.scaricaFattureIntervento(intervento),
          }, */
          {
            label: 'Visualizza',
            icon: PrimeIcons.EYE,
            style: {
              'font-size': '12px',
            },
            command: () => this.mostraStoricoRendicontazione(intervento),
          },
          {
            label: 'Carica Saldo',
            icon: PrimeIcons.RECEIPT,
            style: {
              'font-size': '12px',
            },
            command: () => this.rendicontaIntervento(intervento),
          },
        );
      } else {
        itemRendiconta.push({
          label: 'Aggiungi',
          icon: PrimeIcons.RECEIPT,
          style: {
            'font-size': '12px',
          },
          command: () => this.rendicontaIntervento(intervento),
        });
      }
      this.menuAzioniItems.push({
        label: 'Rendicontazione',
        icon: PrimeIcons.EURO,
        style: {
          'font-size': '12px',
          'font-weight': 'bold',
        },
        items: itemRendiconta,
      });
    } else if (
      (this.isEnteEsecutore &&
        intervento.stato.descrizione.toUpperCase() ==
          'RENDICONTATO COMPLETAMENTE') ||
      intervento.stato.descrizione.toUpperCase() == 'LIQUIDATO PARZIALMENTE' ||
      intervento.stato.descrizione.toUpperCase() == 'LIQUIDATO'
    ) {
      this.menuAzioniItems.push({
        label: 'Rendicontazione',
        icon: PrimeIcons.EURO,
        style: {
          'font-size': '12px',
        },
        command: () => this.mostraStoricoRendicontazione(intervento),
      });
    }

    // LIQUIDATO PARZIALMENTE è già coperto dal blocco sopra (sottomenu Rendicontazione).
    // Non aggiungere qui un secondo item, altrimenti UMVS / ente vedono la voce duplicata.
    if (
      !this.isEnteEsecutore &&
      intervento.stato.descrizione.toUpperCase() ==
        'RENDICONTATO COMPLETAMENTE'
    ) {
      this.menuAzioniItems.push({
        label: 'Rendicontazione',
        icon: PrimeIcons.EURO,
        style: {
          'font-size': '12px',
        },
        command: () => this.mostraStoricoRendicontazione(intervento),
      });
    }

    // Azione di liquidazione: solo per utenti UMVS/ADMIN/SUPERADMIN (isAdminOrUmvs)
    // Regole:
    // - RENDICONTATO PARZIALMENTE + importoLiquidato già valorizzato → NON mostrare
    // - RENDICONTATO COMPLETAMENTE + importoLiquidato < importoRendicontato  → mostrare
    // - RENDICONTATO PARZIALMENTE o COMPLETAMENTE + importoLiquidato non valorizzato → mostrare
    /*  if (this.isAdminOrUmvs && this.canLiquidare(intervento)) {
      this.menuAzioniItems.push({
        label: 'Liquidazione',
        icon: PrimeIcons.CREDIT_CARD,
        style: {
          'font-size': '12px',
          'font-weight': 'bold',
        },
        command: () => this.apriLiquidazione(intervento),
      });
    } */

    /* if(this.isEnteEsecutore && intervento.stato.descrizione.toUpperCase() == "RENDICONTATO COMPLETAMENTE"){
      let itemRendiconta = [
        {
          label: "Scarica doc",
          icon: PrimeIcons.FILE_PDF,
          style: {
            'font-size': '12px',
          },
          command: () => this.scaricaFattureIntervento(intervento),
        },
        {
          label: "Storico",
          icon: PrimeIcons.HISTORY,
          style: {
            'font-size': '12px'
          },
          command: () => this.mostraStoricoRendicontazione(intervento),
        }
      ];
      this.menuAzioniItems.push(
        {
          label: "Rendicontazione",
          icon: PrimeIcons.EURO,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          items: itemRendiconta,
        },
      );
    } */

    if (intervento.stato.descrizione.toUpperCase() == 'IN PREPARAZIONE') {
      this.menuAzioniItems.push(
        {
          label: 'Modifica',
          icon: PrimeIcons.PENCIL,
          style: {
            'font-size': '12px',
            'font-weight': 'bold',
          },
          command: () => this.modificaIntervento(intervento),
        },
        {
          label: 'Elimina',
          icon: PrimeIcons.ERASER,
          style: {
            'font-size': '12px',
            'font-weight': 'bold',
          },
          command: () => this.eliminaIntervento(intervento),
        },
      );
    }
    if (
      (this.isEnteEsecutore &&
        intervento.stato.descrizione.toUpperCase() == 'FINANZIATO') ||
      intervento.stato.descrizione.toUpperCase() ==
        'RENDICONTATO PARZIALMENTE' ||
      intervento.stato.descrizione.toUpperCase() == 'RENDICONTATO COMPLETAMENTE'
    ) {
      const annoCorrente = new Date().getFullYear();
      if (intervento.richiesta?.anno < annoCorrente + 1) {
        if (!this.verificaRichiestaAnnoCorrente(intervento)) {
          this.menuAzioniItems.push({
            label: 'Ripianifica',
            icon: PrimeIcons.COPY,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            command: () => this.clonaIntervento(intervento),
          });
        }
      }

      /* this.menuAzioniItems.push(
        {
          label: "Scarica determina",
          icon: PrimeIcons.FILE_PDF,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          command: () => this.scaricaDeterminaIntervento(intervento),
        }
      ); */
    }
  }

  checkIfCanAddIntervento(): boolean {
    /* if(!this.isEnteEsecutore){
      return true;
    } */
    if (this.filtroRichiestaId) {
      // this.logger.info('[INTERVENTI] checkIfCanAddIntervento ', this.filtroRichiestaId);

      const richiestaToCheck = this.richieste.find(
        (richiesta) => richiesta.id === Number(this.filtroRichiestaId),
      );
      // this.logger.info(richiestaToCheck);
      //this.logger.info('[INTERVENTI] Richiesta selezionata', richiestaToCheck,' stato: '+richiestaToCheck?.stato.descrizione.toUpperCase());
      if (
        richiestaToCheck &&
        richiestaToCheck.stato.descrizione.toUpperCase() == 'IN PREPARAZIONE'
      ) {
        return true;
      }
      return false;
    } else {
      const richiesta = this.richieste.find(
        (richiesta) =>
          richiesta.stato.descrizione.toUpperCase() == 'IN PREPARAZIONE',
      );
      if (richiesta) {
        return true;
      }
    }
    return false;
  }

  mostraInterventoSuMappa(intervento: any) {
    this.schedaIntervento = intervento.scheda;

    if (this.schedaIntervento?.id) {
      // Ottieni i dati GeoJSON di tutte le schede e filtra per ID
      this.schedeService
        .getGeometriaSingolaScheda(this.schedaIntervento?.id)
        .subscribe(
          (geometrie: SchedeFeatureCollection) => {
            // Filtra la feature corrispondente alla scheda selezionata
            const schedaFeature = geometrie.features.find(
              (feature) =>
                feature.properties &&
                feature.properties.id === this.schedaIntervento?.id,
            );

            if (schedaFeature) {
              // Crea una feature collection con solo questa scheda
              this.selectedFeatureGeoJSON = {
                type: 'FeatureCollection',
                features: [schedaFeature],
              };
              this.mappaInterventoTitolo = `Posizione dell'intervento: ${this.schedaIntervento?.codice} - ${this.schedaIntervento?.titolo}`;
              // Apri il modale della mappa
              this.logger.info(
                '[INTERVENTI] Mostra mappa intervento',
                this.selectedFeatureGeoJSON,
              );
              this.showMappaIntervento = true;
            } else {
              this.messageService.add({
                severity: 'warn',
                summary: 'Attenzione',
                detail: 'Nessuna geometria trovata per questa scheda',
                life: 5000,
              });
            }
          },
          (error: Error) => {
            this.logger.error(
              `[SCHEDE] Errore nel recupero delle geometrie delle schede`,
              error,
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Impossibile recuperare le geometrie delle schede',
              life: 5000,
            });
          },
        );
    }
  }

  mostraStoricoIntervento(intervento: Intervento) {
    this.logger.info(
      '[INTERVENTI] Mostra storico intervento',
      intervento?.scheda?.codice,
    );
    this.interventoSelezionato = intervento;
    this.storicoInterventoComponent.show(intervento);
  }

  mostraStoricoRendicontazione(intervento: Intervento) {
    this.logger.info(
      '[INTERVENTI] Mostra storico rendicontazione',
      intervento?.scheda?.codice,
    );
    this.interventoSelezionato = intervento;
    this.statoRendicontazioneComponent.show(intervento);
  }

  modificaNoteIntervento(intervento: Intervento) {
    this.logger.info(
      '[INTERVENTI] Modifica note intervento',
      intervento?.scheda?.codice,
    );
    this.interventoSelezionato = intervento;
    this.modificaNoteInterventoComponent.show(intervento);
  }

  onNoteModificate(): void {
    this.logger.info('[INTERVENTI] Note modificate con successo');
    this.showModificaNoteIntervento = false;
    this.caricaInterventi(); // Ricarica gli interventi per mostrare le modifiche
  }

  assegnaMassivamenteDetermine() {
    this.logger.info('[INTERVENTI] Assegna determine in blocco');
    this.mostraAssegnaMassivamenteDetermine = true;
  }

  onDetermineAssegnate(): void {
    this.logger.info('[INTERVENTI] Determine assegnate con successo');
    this.mostraAssegnaMassivamenteDetermine = false;
    this.caricaInterventi(); // Ricarica gli interventi per mostrare le modifiche
  }

  scaricaReportInterventi() {
    this.isDownloading = true;
    if (this.isEnteEsecutore) {
      const interventiFiltratiPerEnte = this.interventiFiltrati.filter(
        (intervento) =>
          String(intervento.richiesta?.enteEsecutore?.id) ===
          String(this.enteId),
      );
      this.excelService.exportInterventiToExcel(
        interventiFiltratiPerEnte,
        'report_interventi.xlsx',
        true,
      );
    } else {
      // this.logger.info('[INTERVENTI] Scarica report interventi che sono filtrati?', this.enteId);
      this.excelService.exportInterventiToExcel(
        this.interventiFiltrati,
        'report_interventi.xlsx',
        true,
      );
    }
    this.isDownloading = false;
  }

  modificaIntervento(intervento: any) {
    this.logger.info('[INTERVENTI] Modifica intervento', intervento);
    this.interventoSelezionato = intervento;
    this.modificaInterventoComponent.show(intervento);
  }

  eliminaIntervento(intervento: any) {
    // Implementare la logica per eliminare l'intervento
    this.showConfermaCancellazione = true;
    this.interventoDaEliminare = intervento;
  }

  clonaIntervento(intervento: Intervento) {
    this.interventoSelezionato = intervento;
    this.richiestaSelezionata =
      this.richieste.length > 0
        ? this.richieste.reduce(
            (max, richiesta) => (richiesta.anno > max.anno ? richiesta : max),
            this.richieste[0],
          )
        : null;
    setTimeout(() => {
      this.riproponiInterventoComponent.show();
    });
  }

  confermaEliminazione() {
    if (this.interventoDaEliminare?.id) {
      this.interventiService
        .elimina(this.interventoDaEliminare.id)
        .subscribe(() => {
          this.showConfermaCancellazione = false;
          this.interventoDaEliminare = null;

          this.messageService.add({
            severity: 'success',
            summary: 'ELIMINAZIONE INTERVENTO',
            detail: 'Intervento eliminato con successo',
            life: 3000,
            styleClass: 'custom-toast', // Aggiungere una classe CSS personalizzata
          });
          this.caricaInterventi();
        });
    }
  }

  finanziaIntervento(intervento: any) {
    this.interventoConfermaFinanziamento = intervento;
    this.logger.info(
      '[INTERVENTI] Finanzia intervento: ',
      this.interventoConfermaFinanziamento,
    );
    if (this.interventoConfermaFinanziamento) {
      this.confermaFinanziamentoComponent.show(
        this.interventoConfermaFinanziamento,
      );
    }
  }

  onConfermaFinanziamento(importoFinanziato: number) {
    this.messageService.add({
      severity: 'success',
      summary: 'Finanziamento confermato',
      detail: `Importo finanziato: ${importoFinanziato}€`,
      life: 3000,
    });
    this.caricaInterventi();
  }

  rimodulaRichiesta(intervento: any) {
    this.interventoRimodulaRichiesta = intervento;
    this.rimodulaRichiestaComponent.show(this.interventoRimodulaRichiesta);
  }

  onRimodulaRichiesta(intervento: Intervento | null) {
    this.logger.info('[INTERVENTI] onRimodulaRichiesta: ', intervento);
    if (intervento) {
      this.messageService.add({
        severity: 'success',
        summary: 'Rimodulazione richiesta',
        detail: `Importo rimodulato con successo`,
        life: 3000,
      });
      this.caricaInterventi();
    }
  }

  onComunicaDetermina(intervento: any) {
    this.messageService.add({
      severity: 'success',
      summary: 'Determina comunicata',
      detail: `Determina comunicata con successo`,
      life: 3000,
    });
    this.caricaInterventi();
  }

  onConfermaContributo(importo: number) {
    // Implementare la logica per salvare l'importo del contributo
    this.messageService.add({
      severity: 'success',
      summary: 'Contributo comunicato',
      detail: `Importo comunicato: ${importo}€`,
      life: 3000,
    });
  }

  rivediImportoIntervento(intervento: any) {
    // Implementare la logica per rivedere l'importo dell'intervento
  }

  rendicontaIntervento(intervento: any) {
    this.rendicontaComponent.show(intervento);
  }

  scaricaFattureIntervento(intervento: any) {
    this.isDownloading = true;
    this.logger.info(
      '[INTERVENTI] Scaricamento fatture intervento',
      intervento,
    );
    const path = `interventi/${intervento.id}/fatture`;
    this.firebaseStorageService.listFiles(path).subscribe({
      next: (files) => {
        files.forEach((fileName) => {
          this.logger.info(
            '[INTERVENTI] Scaricamento fattura intervento',
            fileName,
          );
          this.firebaseStorageService.downloadFile(`${fileName}`).subscribe({
            next: (blob: Blob) => {
              // Estrai il nome del file dal path completo rimuovendo i parametri di query
              const nomeFile = decodeURIComponent(
                fileName.split('/').pop()?.split('?')[0] || fileName,
              );
              const nomeFileFinale = nomeFile.split('/').pop() || nomeFile;
              this.logger.info(
                '[INTERVENTI] Nome file estratto:',
                nomeFileFinale,
              );
              saveAs(blob, nomeFileFinale);
              this.isDownloading = false;
            },
            error: (error: Error) => {
              this.logger.error(
                `[INTERVENTI] Errore durante il download del file ${fileName}:`,
                error,
              );
              this.messageService.add({
                severity: 'error',
                summary: 'Errore',
                detail: `Impossibile scaricare il file ${fileName}`,
              });
            },
          });
        });
      },
      error: (error: Error) => {
        this.logger.error(
          '[INTERVENTI] Errore durante il recupero della lista dei file:',
          error,
        );
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile recuperare la lista dei file',
        });
      },
    });
  }

  mostraFattureIntervento(intervento: any) {
    //this.mostraFattureInterventoComponent.show(intervento);
  }

  comunicaDetermina(intervento: any) {
    this.determinaComponent.show(intervento);
  }

  aggiungiIntervento() {
    this.nuovoInterventoComponent.show();
  }
  onInterventoCreato(intervento: Intervento) {
    this.logger.info('[INTERVENTI] Intervento creato', intervento);
    this.messageService.add({
      severity: 'success',
      summary: 'CREAZIONE INTERVENTO',
      detail: 'Intervento creato con successo',
      life: 3000,
    });
    this.caricaInterventi();
  }

  onInterventoModificato(intervento: Intervento) {
    this.logger.info('[INTERVENTI] Intervento modificato', intervento);
    this.messageService.add({
      severity: 'success',
      summary: 'MODIFICA INTERVENTO',
      detail: 'Intervento modificato con successo',
      life: 3000,
    });
    this.caricaInterventi();
  }

  onRendiconta(importo: number) {
    this.messageService.add({
      severity: 'success',
      summary: 'Rendicontazione completata',
      detail: `Importo rendicontato: ${importo}€`,
      life: 3000,
    });
    this.caricaInterventi();
  }

  private inizializzaAnniDisponibili() {
    const annoCorrente = new Date().getFullYear();
    this.anniDisponibili = Array.from({ length: 5 }, (_, i) => {
      const anno = annoCorrente - i;
      return {
        label: anno.toString(),
        value: anno,
      };
    });
  }

  onStatoChange(event: any) {
    if (event.value) {
      // Controlla se è l'opzione "Rimuovi filtro"
      if (event.value.isRemoveOption || event.value.id === 'remove-filter') {
        // Rimuovi il filtro stato quando viene selezionata l'opzione "Rimuovi filtro"
        this.statoSelezionato = null;

        // Verifica se altri filtri sono attivi
        this.updateFiltriAttivi();

        if (this.dt) {
          // Rimuovi il filtro dello stato impostandolo a null
          this.dt.filter(null, 'stato.descrizione', 'equals');

          // Riapplica gli altri filtri se presenti
          if (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) {
            this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
          }
          if (this.filtri.bacino) {
            this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
          }
          if (this.filtri.comune) {
            this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
          }
          if (this.isAnnoValido(this.richiestaSelezionata)) {
            this.dt.filter(
              (this.richiestaSelezionata as any).anno,
              'richiesta.anno',
              'equals',
            );
          }

          // Aggiorna gli interventi filtrati
          this.interventiFiltrati = this.dt.filteredValue || this.interventi;

          this.logger.info(
            '[INTERVENTI] Filtro stato rimosso, interventi filtrati: ' +
              this.interventiFiltrati.length,
          );

          if (this.map && this.activeTabIndex === 1) {
            this.aggiornaMarkerMappa(this.interventiFiltrati);
          }
        } else {
          // Se la tabella non è disponibile, aggiorna comunque gli interventi filtrati
          this.interventiFiltrati = this.interventi;
          if (this.map && this.activeTabIndex === 1) {
            this.aggiornaMarkerMappa(this.interventiFiltrati);
          }
        }
        return;
      }

      let stato = event.value.descrizione;
      this.filtriAttivi = true; // Imposta flag filtri attivi
      if (this.dt) {
        this.dt.filter(stato, 'stato.descrizione', 'equals');

        this.interventiFiltrati = this.interventi.filter(
          (intervento) => intervento.stato.id?.descrizione === event.value.id,
        );
        if (this.map && this.activeTabIndex === 1) {
          this.aggiornaMarkerMappa(this.interventiFiltrati);
        } else if (!this.map) {
          this.logger.warn(
            '[INTERVENTI] Mappa non ancora inizializzata, impossibile aggiornare i marker',
          );
        }
      }
    } else {
      // Verifica se altri filtri sono attivi
      this.updateFiltriAttivi();
      if (this.dt) {
        this.dt.reset();
        this.interventiFiltrati = this.interventi;
        if (this.map && this.activeTabIndex === 1) {
          this.aggiornaMarkerMappa(this.interventiFiltrati);
        }
      }
    }
  }

  onAnnoChange(event: any) {
    if (event.value) {
      // Controlla se è l'opzione "Rimuovi filtro"
      if (event.value.isRemoveOption || event.value.id === 'remove-filter') {
        // Rimuovi il filtro anno quando viene selezionata l'opzione "Rimuovi filtro"
        this.filtri.anno = null;
        this.richiestaSelezionata = null;

        // Verifica se altri filtri sono attivi
        this.updateFiltriAttivi();

        if (this.dt) {
          // Rimuovi il filtro dell'anno impostandolo a null
          this.dt.filter(null, 'richiesta.anno', 'equals');

          // Riapplica gli altri filtri se presenti
          if (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) {
            this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
          }
          if (this.filtri.bacino) {
            this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
          }
          if (this.filtri.comune) {
            this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
          }
          if (this.statoSelezionato) {
            this.dt.filter(this.statoSelezionato.id, 'stato.id', 'equals');
          }

          // Aggiorna gli interventi filtrati
          this.interventiFiltrati = this.dt.filteredValue || this.interventi;

          this.logger.info(
            '[INTERVENTI] Filtro anno rimosso, interventi filtrati: ' +
              this.interventiFiltrati.length,
          );

          if (this.map && this.activeTabIndex === 1) {
            this.aggiornaMarkerMappa(this.interventiFiltrati);
          }
        } else {
          // Se la tabella non è disponibile, aggiorna comunque gli interventi filtrati
          this.interventiFiltrati = this.interventi;
          if (this.map && this.activeTabIndex === 1) {
            this.aggiornaMarkerMappa(this.interventiFiltrati);
          }
        }
        return;
      }

      let anno = event.value.anno;
      // Filtra gli interventi per l'anno selezionato
      this.filtri.anno = event.value.anno;
      this.filtriAttivi = true;
      if (this.dt) {
        this.dt.filter(anno, 'richiesta.anno', 'equals');
        this.interventiFiltrati = this.interventi.filter(
          (intervento) => intervento.richiesta?.anno === anno,
        );
        this.logger.info(
          '[INTERVENTI] Anno selezionato ' +
            anno +
            ' interventi filtrati ' +
            this.interventiFiltrati.length,
        );

        // Verifica che la mappa sia inizializzata e siamo nella tab della mappa prima di aggiornare i marker
        if (this.map && this.activeTabIndex === 1) {
          this.aggiornaMarkerMappa(this.interventiFiltrati);
        } else if (!this.map) {
          this.logger.warn(
            '[INTERVENTI] Mappa non ancora inizializzata, impossibile aggiornare i marker',
          );
        }
      }
    } else {
      // Rimuovi il filtro anno quando viene deselezionato
      this.filtri.anno = null;
      this.richiestaSelezionata = null;

      // Verifica se altri filtri sono attivi
      this.updateFiltriAttivi();

      if (this.dt) {
        // Rimuovi il filtro dell'anno impostandolo a null
        // In PrimeNG Table, per rimuovere un filtro specifico, lo impostiamo a null
        this.dt.filter(null, 'richiesta.anno', 'equals');

        // Riapplica gli altri filtri se presenti
        if (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) {
          this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
        }
        if (this.filtri.bacino) {
          this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
        }
        if (this.filtri.comune) {
          this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
        }
        if (this.statoSelezionato) {
          this.dt.filter(this.statoSelezionato.id, 'stato.id', 'equals');
        }

        // Aggiorna gli interventi filtrati
        this.interventiFiltrati = this.dt.filteredValue || this.interventi;

        this.logger.info(
          '[INTERVENTI] Filtro anno rimosso, interventi filtrati: ' +
            this.interventiFiltrati.length,
        );

        if (this.map && this.activeTabIndex === 1) {
          this.aggiornaMarkerMappa(this.interventiFiltrati);
        }
      } else {
        // Se la tabella non è disponibile, aggiorna comunque gli interventi filtrati
        this.interventiFiltrati = this.interventi;
        if (this.map && this.activeTabIndex === 1) {
          this.aggiornaMarkerMappa(this.interventiFiltrati);
        }
      }
    }
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index;
    if (event.index === 1) {
      // Tab Mappa
      setTimeout(() => {
        if (!this.map) {
          this.initializeMap();
        }
        this.caricaGeometrieInterventi();
        this.caricaConfiniComuni();

        // Aggiorna i marker della mappa con i dati filtrati correnti
        if (this.map) {
          const interventiFiltrati = this.dt?.filteredValue || this.interventi;
          this.aggiornaMarkerMappa(interventiFiltrati);
        }
      }, 100);
    }
  }

  private initializeMap(): void {
    if (this.map) {
      this.map.remove();
    }

    if (!this.mapContainer || !this.mapContainer.nativeElement) {
      this.logger.error('Elemento mappa non trovato nel DOM');
      return;
    }

    try {
      this.map = new maplibregl.Map({
        container: this.mapContainer.nativeElement,
        style: {
          version: 8,
          sources: {
            'osm-tiles': {
              type: 'raster',
              tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
              tileSize: 256,
              // attribution: '© OpenStreetMap contributors'
            },
          },
          layers: [
            {
              id: 'osm-tiles',
              type: 'raster',
              source: 'osm-tiles',
              minzoom: 0,
              maxzoom: 19,
            },
          ],
        },
        center: [7.2, 45.1381],
        zoom: 10.2,
      });

      this.map.on('load', () => {
        this.logger.info('[INTERVENTI] Mappa inizializzata');
        // Aggiungi i controlli della mappa
        (this.map as any).addControl(
          new maplibregl.NavigationControl(),
          'top-right',
        );
        (this.map as any).addControl(
          new maplibregl.FullscreenControl(),
          'top-right',
        );

        // Aggiungi i marker iniziali solo se siamo nella tab della mappa
        if (this.activeTabIndex === 1) {
          const interventiFiltrati = this.dt?.filteredValue || this.interventi;
          this.aggiornaMarkerMappa(interventiFiltrati);
        }

        // Gestisci lo zoom alle coordinate del comune se presenti
        const longitudineComune = localStorage.getItem('longitudineComune');
        const latitudineComune = localStorage.getItem('latitudineComune');

        if (
          this.isEnteEsecutore &&
          longitudineComune &&
          latitudineComune &&
          this.map &&
          this.activeTabIndex === 1
        ) {
          // Ottieni gli interventi filtrati
          const interventiFiltrati = this.dt?.filteredValue || this.interventi;

          // Crea un array di coordinate valide
          const coordinates = interventiFiltrati
            .filter(
              (intervento) => intervento.latitudine && intervento.longitudine,
            )
            .map((intervento) => ({
              lng: parseFloat(intervento.longitudine),
              lat: parseFloat(intervento.latitudine),
            }));

          this.logger.info(
            '[INTERVENTI] Coordinate trovate:',
            coordinates.length,
          );

          if (coordinates.length > 0) {
            // Crea il bounding box
            const bounds = coordinates.reduce(
              (bounds, coord) => {
                return bounds.extend(coord);
              },
              new maplibregl.LngLatBounds(coordinates[0], coordinates[0]),
            );

            this.logger.info('[INTERVENTI] Bounding box creato:', bounds);

            // Aggiungi un po' di padding al bounding box
            const padding = { top: 50, bottom: 50, left: 50, right: 50 };

            // Esegui lo zoom al bounding box
            setTimeout(() => {
              if (coordinates.length === 1) {
                // Se c'è un solo marker, usa un livello di zoom più alto
                (this.map as any).flyTo({
                  center: coordinates[0],
                  zoom: 12,
                  essential: true,
                  duration: 2000,
                });
              } else {
                // Se ci sono più marker, usa il bounding box
                (this.map as any).fitBounds(bounds, {
                  padding: padding,
                  duration: 2000,
                  essential: true,
                });
              }
              this.logger.info('[INTERVENTI] Zoom eseguito');
            }, 500);
          } else {
            this.logger.info(
              '[INTERVENTI] Nessuna coordinata valida, zoom al centro del comune',
            );
            // Se non ci sono coordinate valide, usa il centro del comune
            setTimeout(() => {
              (this.map as any).flyTo({
                center: [
                  parseFloat(longitudineComune),
                  parseFloat(latitudineComune),
                ],
                zoom: 9,
                essential: true,
                duration: 2000,
              });
            }, 500);
          }
        }
      });

      this.map.on('error', (e: Error) => {
        this.logger.error('Errore nella mappa:', e);
      });
    } catch (error) {
      this.logger.error(
        "Errore durante l'inizializzazione della mappa:",
        error,
      );
    }
  }

  private caricaGeometrieInterventi(): void {
    this.interventi.forEach((intervento) => {
      if (intervento.schedaId) {
        this.schedeService
          .getGeometriaSingolaScheda(intervento.schedaId)
          .subscribe(
            (featureCollection: SchedeFeatureCollection) => {
              if (
                featureCollection.features &&
                featureCollection.features.length > 0
              ) {
                featureCollection.features.forEach((feature) => {
                  this.aggiungiFeatureAllaMappa(feature, intervento);
                });
              }
            },
            (error: Error) => {
              this.logger.error(
                'Errore nel caricamento della geometria:',
                error,
              );
            },
          );
      }
    });
  }

  private aggiungiFeatureAllaMappa(feature: any, intervento: any): void {
    if (!this.map) return;

    const layerId = `intervento-${intervento.id}`;
    const sourceId = `source-${layerId}`;

    // Converti le coordinate da UTM a WGS84 se necessario
    this.convertCoordinates(feature.geometry);

    // Aggiungi la sorgente
    (this.map as any).addSource(sourceId, {
      type: 'geojson',
      data: feature,
    });

    // Aggiungi il layer
    (this.map as any).addLayer({
      id: layerId,
      type: 'fill',
      source: sourceId,
      paint: {
        'fill-color': '#088',
        'fill-opacity': 0.4,
        'fill-outline-color': '#000',
      },
    });

    // Aggiungi interattività
    this.aggiungiInterattivitaLayer(layerId, intervento);
  }

  private aggiungiInterattivitaLayer(layerId: string, intervento: any): void {
    if (!this.map) return;

    // Hover effect
    (this.map as any).on('mouseenter', layerId, () => {
      (this.map as any).getCanvas().style.cursor = 'pointer';
      (this.map as any).setPaintProperty(layerId, 'fill-opacity', 0.7);
    });

    (this.map as any).on('mouseleave', layerId, () => {
      (this.map as any).getCanvas().style.cursor = '';
      (this.map as any).setPaintProperty(layerId, 'fill-opacity', 0.4);
    });

    // Click event
    (this.map as any).on('click', layerId, () => {
      this.mostraInterventoSuMappa(intervento);
    });
  }

  private caricaConfiniComuni(): void {
    this.comuniService.getConfiniComuni().subscribe(
      (data: ComuniFeatureCollection) => {
        this.comuniData = data;
        this.aggiungiConfiniComuni();
      },
      (error: Error) => {
        this.logger.error(
          'Errore nel caricamento dei confini dei comuni:',
          error,
        );
      },
    );
  }

  private aggiungiConfiniComuni(): void {
    if (!this.map || !this.comuniData) return;

    // Rimuovi la sorgente e il layer se esistono
    if ((this.map as any).getSource('comuni')) {
      if ((this.map as any).getLayer('comuni-boundaries')) {
        (this.map as any).removeLayer('comuni-boundaries');
      }
      (this.map as any).removeSource('comuni');
    }

    // Aggiungi la nuova sorgente
    (this.map as any).addSource('comuni', {
      type: 'geojson',
      data: this.comuniData,
    });

    // Aggiungi il nuovo layer
    (this.map as any).addLayer({
      id: 'comuni-boundaries',
      type: 'line',
      source: 'comuni',
      paint: {
        'line-color': '#000',
        'line-width': 1,
      },
    });
  }

  private convertCoordinates(geometry: any): void {
    if (!geometry || !geometry.coordinates) return;

    const fromProj = 'EPSG:32633'; // UTM zone 33N
    const toProj = 'EPSG:4326'; // WGS84

    const convertCoordinate = (coord: number[]): number[] => {
      return proj4(fromProj, toProj, coord);
    };

    if (geometry.type === 'Point') {
      geometry.coordinates = convertCoordinate(geometry.coordinates);
    } else if (geometry.type === 'LineString') {
      geometry.coordinates = geometry.coordinates.map(convertCoordinate);
    } else if (geometry.type === 'Polygon') {
      geometry.coordinates = geometry.coordinates.map((ring: number[][]) =>
        ring.map(convertCoordinate),
      );
    }
  }

  private verificaRichiestaAnnoCorrente(intervento: Intervento): boolean {
    const annoCorrente = new Date().getFullYear() + 1;
    /*  if(intervento.richiesta?.anno == annoCorrente){
      return true;
    }
 */
    const interventiAnnoCorrente = this.interventi.filter(
      (i) => i.richiesta?.anno == annoCorrente,
    );
    if (interventiAnnoCorrente.length > 0) {
      const interventoAnnoCorrente = interventiAnnoCorrente.find(
        (i) => i.scheda?.id == intervento.scheda?.id,
      );
      if (interventoAnnoCorrente) {
        this.logger.info(
          "SCHEDA GIA' PRESENTE NON DEVO FARLA CLONARE",
          interventoAnnoCorrente,
        );
        return true;
      }
    }
    this.logger.info(
      'SCHEDA NON PRESENTE LA FACCIO CLONARE ' + intervento.scheda?.codice,
    );
    return false;
  }

  onRiproposizioneConfermata(intervento: Intervento) {
    this.logger.info(
      '[INTERVENTI] Riproposizione intervento confermata',
      intervento,
    );
    this.messageService.add({
      severity: 'success',
      summary: 'Riproposto',
      detail: 'Intervento riproposto con successo',
      life: 3000,
    });
    this.caricaInterventi();
  }

  // Metodi per calcolare i totali
  public isInterventoDellEnte(intervento: any): boolean {
    const result =
      !this.isEnteEsecutore ||
      String(intervento.richiesta?.enteEsecutore?.id) === String(this.enteId);
    /* this.logger.info('[INTERVENTI] isInterventoDellEnte:', {
      interventoId: intervento.id,
      isEnteEsecutore: this.isEnteEsecutore,
      enteIntervento: intervento.richiesta?.enteEsecutore?.id,
      enteId: this.enteId,
      result: result
    }); */
    return result;
  }

  getTotaleImportoRichiesto(): number {
    const interventiFiltrati = this.dt?.filteredValue || this.interventi;
    return interventiFiltrati.reduce((totale, intervento) => {
      return this.isInterventoDellEnte(intervento)
        ? totale + (intervento.importoRichiesto || 0)
        : totale;
    }, 0);
  }

  getTotaleImportoRimodulato(): number {
    const interventiFiltrati = this.dt?.filteredValue || this.interventi;
    return interventiFiltrati.reduce((totale, intervento) => {
      return this.isInterventoDellEnte(intervento)
        ? totale + (intervento.importoRimodulato || 0)
        : totale;
    }, 0);
  }

  getTotaleImportoFinanziato(): number {
    const interventiFiltrati = this.dt?.filteredValue || this.interventi;
    return interventiFiltrati.reduce((totale, intervento) => {
      return this.isInterventoDellEnte(intervento)
        ? totale + (intervento.importoFinanziato || 0)
        : totale;
    }, 0);
  }

  getTotaleImportoRendicontato(): number {
    const interventiFiltrati = this.dt?.filteredValue || this.interventi;
    return interventiFiltrati.reduce((totale, intervento) => {
      return this.isInterventoDellEnte(intervento)
        ? totale + (intervento.importoRendicontato || 0)
        : totale;
    }, 0);
  }

  getTotaleImportoLiquidato(): number {
    const interventiFiltrati = this.dt?.filteredValue || this.interventi;
    return interventiFiltrati.reduce((totale, intervento) => {
      return this.isInterventoDellEnte(intervento)
        ? totale + (intervento.importoLiquidato || 0)
        : totale;
    }, 0);
  }

  isInterventoLiquidato(intervento: Intervento): boolean {
    const statoDescrizione =
      intervento?.stato?.descrizione?.toUpperCase().trim() || '';
    return statoDescrizione === 'LIQUIDATO';
  }

  apriLiquidazione(intervento: Intervento) {
    this.interventoLiquidazione = intervento;

    this.mostraLiquidazione = true;
  }

  canLiquidare(intervento: any): boolean {
    if (!intervento) return false;

    const isParziale = this.isRendicontazioneParziale(intervento);
    const isCompleta = this.isRendicontazioneCompleta(intervento);

    if (!isParziale && !isCompleta) return false;

    const importoLiquidato = intervento.importoLiquidato ?? 0;
    const importoRendicontato = intervento.importoRendicontato ?? 0;

    // Parzialmente + già liquidato → non mostrare
    if (isParziale && importoLiquidato > 0) return false;

    // Completamente + liquidato pari o superiore al rendicontato → non mostrare
    if (
      isCompleta &&
      importoLiquidato >= importoRendicontato &&
      importoLiquidato > 0
    )
      return false;

    return true;
  }

  isRendicontazioneParziale(intervento: any): boolean {
    if (!intervento) {
      return false;
    }

    const statoDescrizione =
      intervento.stato?.descrizione?.toUpperCase().trim() || '';

    if (statoDescrizione === StatoInterventoEnum.RENDICONTATO_PARZIALMENTE) {
      return true;
    }

    if (statoDescrizione === StatoInterventoEnum.RENDICONTATO_COMPLETAMENTE) {
      return false;
    }

    const importoFinanziato = intervento.importoFinanziato || 0;
    const importoRendicontato = intervento.importoRendicontato || 0;

    return (
      importoFinanziato > 0 &&
      importoRendicontato > 0 &&
      importoRendicontato < importoFinanziato
    );
  }

  isRendicontazioneCompleta(intervento: any): boolean {
    if (!intervento) {
      return false;
    }

    const statoDescrizione =
      intervento.stato?.descrizione?.toUpperCase().trim() || '';

    if (statoDescrizione === StatoInterventoEnum.RENDICONTATO_COMPLETAMENTE) {
      return true;
    }

    if (statoDescrizione === StatoInterventoEnum.RENDICONTATO_PARZIALMENTE) {
      return false;
    }

    const importoFinanziato = intervento.importoFinanziato || 0;
    const importoRendicontato = intervento.importoRendicontato || 0;

    return (
      importoFinanziato > 0 &&
      importoRendicontato > 0 &&
      importoRendicontato >= importoFinanziato
    );
  }

  getRendicontazioneTooltip(intervento: any): string {
    if (!intervento || !intervento.importoRendicontato) {
      return 'Importo rendicontato';
    }

    if (this.isRendicontazioneCompleta(intervento)) {
      return 'Rendicontazione COMPLETA';
    }

    if (this.isRendicontazioneParziale(intervento)) {
      return 'Rendicontazione PARZIALE';
    }

    return 'Importo rendicontato';
  }

  private mostraAvvisoInterventiSenzaCoordinate(numeroInterventi: number) {
    // Rimuovi eventuali avvisi precedenti
    this.rimuoviAvvisoInterventiSenzaCoordinate();

    // Ottieni gli interventi senza coordinate
    const interventiFiltrati = this.dt?.filteredValue || this.interventi;
    const interventiSenzaCoord = interventiFiltrati.filter(
      (intervento) => !intervento.latitudine || !intervento.longitudine,
    );

    // Estrai i codici delle schede (massimo 5 da mostrare)
    const codiciSchede = interventiSenzaCoord
      .filter((intervento) => intervento.scheda?.codice)
      .map((intervento) => intervento.scheda.codice)
      .slice(0, 5);

    const interventiSenzaCoordinate =
      interventiSenzaCoord.length > 5
        ? `e altri ${interventiSenzaCoord.length - 5} interventi`
        : '';

    // Crea il container dell'avviso
    const avvisoElement = document.createElement('div');
    avvisoElement.id = 'avviso-interventi-senza-coordinate';
    avvisoElement.style.cssText = `
      position: absolute;
      bottom: 20px;
      left: 20px;
      background-color: rgba(255, 255, 255, 0.9);
      padding: 12px 16px;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      font-size: 14px;
      max-width: 350px;
      z-index: 10;
      border-left: 4px solid #ff9800;
    `;

    avvisoElement.innerHTML = `
      <div style="display: flex; align-items: center;">
        <i class="pi pi-exclamation-triangle" style="color: #ff9800; margin-right: 10px; font-size: 18px;"></i>
        <div>
          <div style="font-weight: 700; margin-bottom: 2px;">${numeroInterventi} ${numeroInterventi === 1 ? 'intervento non visualizzato' : 'interventi non visualizzati'} per mancanza di geometria:</div>
          <div style="font-size: 12px;"> ${codiciSchede.join(', ')} ${interventiSenzaCoordinate}</div>
        </div>
      </div>
    `;
    //          <div style="font-size: 11px; margin-top: 4px; color: #666;">Queste schede mancano di geometria e non possono essere visualizzate sulla mappa.</div>

    this.mapContainer.nativeElement.appendChild(avvisoElement);
  }

  private rimuoviAvvisoInterventiSenzaCoordinate() {
    const avvisoElement = document.getElementById(
      'avviso-interventi-senza-coordinate',
    );
    if (avvisoElement && avvisoElement.parentNode) {
      avvisoElement.parentNode.removeChild(avvisoElement);
    }
  }

  onToggleFilter() {
    if (this.showOnlyMyInterventi) {
      // Filtra gli interventi per mostrare solo quelli dell'ente corrente
      this.interventi = this.interventiOriginali.filter((intervento) =>
        this.isInterventoDellEnte(intervento),
      );
    } else {
      // Ripristina gli interventi originali
      this.interventi = [...this.interventiOriginali];
    }

    // Aggiorna la tabella se necessario
    if (this.dt) {
      this.dt.reset();
      if (this.filtroTestoGlobale) {
        this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
      }
    }

    // Aggiorna anche la mappa se è attiva
    if (this.map && this.activeTabIndex === 1) {
      const interventiFiltrati = this.dt?.filteredValue || this.interventi;
      this.aggiornaMarkerMappa(interventiFiltrati);
    }
  }

  /**
   * Metodo helper per verificare se una richiesta è un anno valido (non è l'opzione "Rimuovi filtro")
   */
  isAnnoValido(richiesta: any): boolean {
    return (
      richiesta &&
      !richiesta.isRemoveOption &&
      richiesta.id !== 'remove-filter' &&
      typeof richiesta.anno === 'number'
    );
  }

  /**
   * Metodo helper per verificare se uno stato è valido (non è l'opzione "Rimuovi filtro")
   */
  isStatoValido(stato: any): boolean {
    return stato && !stato.isRemoveOption && stato.id !== 'remove-filter';
  }

  /**
   * Metodo helper per ottenere il colore dell'anno per il dropdown
   */
  getColoreAnno(anno: number): string {
    return this.stiliService.getColoreAnnoRichiesta({ anno: anno } as any);
  }
}
